module.exports = __webpack_public_path__ + "img/system22-details.eec14d03.png";